function renderChart2(chartId, legendDivId) {

    var chartData = [];
    var datasetarray1 = datapoint1.data;
    var datasetarray2 = datapoint4.data;
    var datasetarray3 = datapoint3.data;
    var peakinfo1 = datapoint1Peakinfo.PeakInfo;
    var peakinfo2 = datapoint4Peakinfo.PeakInfo;
    var peakinfo3 = datapoint3Peakinfo.PeakInfo;

    generateChartData();

    function generateChartData() {
        
        var maxLenght = datasetarray1.length;
        if(maxLenght < datasetarray2.length){
            maxLenght = datasetarray2.length;
        }
        if(maxLenght < datasetarray3.length){
            maxLenght = datasetarray3.length;
        }
        
        for (var i = 0; i < maxLenght; i++) {
            var xVal1 = datasetarray1[i][0];
            var yVal1 = datasetarray1[i][1];
            
            var xVal2 = datasetarray2[i][0];
            var yVal2 = datasetarray2[i][1];
            
            var xVal3 = datasetarray3[i][0];
            var yVal3 = datasetarray3[i][1];
            
        }
        
       /* var datasetarray1 = datapoint1.data;
        for (var i = 0; i < datasetarray1.length; i++) {
            var xVal = datasetarray1[i][0];
            var yVal = datasetarray1[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo1.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo1[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity": yVal,
                        "label": peakinfo1[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity": yVal
                })
            }

        }

        var datasetarray2 = datapoint4.data;
        for (var i = 0; i < datasetarray2.length; i++) {
            var xVal = datasetarray2[i][0];
            var yVal = datasetarray2[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo2.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo2[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity2": yVal,
                        "label": peakinfo2[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity2": yVal
                })
            }

        }

        var datasetarray3 = datapoint3.data;
        for (var i = 0; i < datasetarray3.length; i++) {
            var xVal = datasetarray3[i][0];
            var yVal = datasetarray3[i][1];
            var flag = 0;

            for (var j = 0; j < peakinfo3.length; j++) {

                if (parseFloat(xVal) == parseFloat(peakinfo3[j].xval)) {
                    chartData.push({
                        "eV": xVal,
                        "intensity3": yVal,
                        "label": peakinfo3[j].lbltext
                    })
                    flag = 1;
                }
            }

            if (flag == 0) {
                chartData.push({
                    "eV": xVal,
                    "intensity3": yVal
                })
            }

        }*/


    }


    var chart = AmCharts.makeChart(chartId, {
        "type": "serial",
        "categoryField": "eV",
        "categoryAxis": {
            "axisColor": "#DADADA"
        },
        "export": {
            "enabled": true
        },
        "valueAxes": [{
            "id": "v1",
            "axisColor": "#FF6600",
            "axisThickness": 2,
            "gridAlpha": 1,
            "axisAlpha": 1,
            "position": "left"
    }],
        "graphs": [
            {
                "valueAxis": "v1",
                "title": "Si (100) survey",
                "type": "line",
                "lineAlpha": 1,
                "valueField": "intensity",
                "lineColor": '#FF9E01',
                "labelText": "[[label]]",
                "fillAlphas": 0
		}, {
                "valueAxis": "v1",
                "title": "Kovar sheet, 700C treatment survey",
                "type": "line",
                "lineAlpha": 1,
                "valueField": "intensity2",
                "lineColor": '#FF0811',
                "labelText": "[[label]]",
                "fillAlphas": 0
		}, {
                "valueAxis": "v1",
                "title": "Al2O3 thin film survey",
                "type": "line",
                "lineAlpha": 1,
                "valueField": "intensity3",
                "lineColor": '#084bff',
                "labelText": "[[label]]",
                "fillAlphas": 0
		}

	],
        "dataProvider": chartData

    });


    var legend = new AmCharts.AmLegend();
    legend.position = "left"
    legend.align = "center";
    legend.markerType = "square";
    legend.valueText = "title";
    chart.addLegend(legend, legendDivId);
}
